<div class="flex flex-col w-full h-full border-[thin] border-color-light-shade border-solid border-y-0 border-r-0">
  <div
    class="flex-none flex px-6 py-3 flex-row items-center justify-between w-full min-h-16 h-16 border-b-[thin] border-color-light-shade border-solid border-x-0 border-t-0 gap-3"
  >
    <div class="flex flex-row items-center gap-2">
      <p class="text-color-primary text-sm font-semibold p-0 m-0 truncate grow max-w-[180px]">
        {{ options?.item?.name }}
      </p>
      <mat-icon class="flex-none text-color-old-gray-50 w-5 h-5 max-h-5 max-w-5 text-[20px]">chevron_right</mat-icon>
      <p class="flex-none text-color-neutral-secondary text-sm font-normal p-0 m-0 truncate">
        @if (options?.type === 'equipment') {
          {{ 'ASSETS_TREE.DETAILS_SECTION.PAGES.EQUIPMENTS' | translate }}
        }
        @if (options?.type === 'maintenance') {
          {{ 'ASSETS_TREE.DETAILS_SECTION.PAGES.MAINTENANCES' | translate }}
        }
      </p>
    </div>
    <div class="flex-none flex flex-row items-center gap-3">
      <palantir-button icon="close-outline" size="xs" theme="outline" layout="icon" (click)="close()"></palantir-button>
    </div>
  </div>

  <ng-scrollbar class="grow w-full h-full overflow-auto relative" [visibility]="'hover'" autoHeightDisabled="false">
    <div class="p-5 flex flex-col gap-3 w-full">
      @if (options?.type === 'equipment') {
        @if (!isLoading()) {
          @for (item of result()?.items; track $index; let i = $index) {
            <div
              class="cursor-pointer w-full bg-white border-[thin] border-solid border-color-light-shade rounded-xl p-3 flex flex-row items-center justify-between gap-2 hover:bg-color-surface hover:border-[#99BBFF] transition-all ease-in-out duration-300"
              (mouseover)="isHoveringIndex.set(i)"
              (mouseout)="isHoveringIndex.set(-1)"
              (click)="emitEvent(item)"
            >
              <div
                class="w-8 h-8 flex-none rounded-full flex items-center justify-center transition-all ease-in-out duration-300"
                [ngClass]="{
                  'bg-white': isHoveringIndex() === i,
                  'bg-color-surface': isHoveringIndex() !== i,
                }"
              >
                @if (item.imageUrl) {
                  <img [src]="item.imageUrl" [alt]="item.name" class="w-full h-full rounded-full object-cover" />
                }
                @if (!item.imageUrl) {
                  <mat-icon class="max-h-4 h-4 max-w-4 w-4 text-[16px] text-color-primary rounded-full">
                    precision_manufacturing
                  </mat-icon>
                }
              </div>
              <p class="grow truncate text-sm p-0 m-0 text-color-neutral">
                {{ item.name }}
              </p>
              @if (item.archived) {
                <div
                  class="flex-none flex flex-row items-center gap-1 p-[6px] rounded-full transition-all ease-in-out duration-300"
                  [style.backgroundColor]="isHoveringIndex() === i ? '#FFFFFF' : maintenanceStatusColorsOpacity10.archived"
                >
                  <div class="w-2 h-2 rounded-full bg-color-old-gray-50"></div>
                  <p class="p-0 m-0 text-color-old-gray-50 font-medium text-xs">
                    {{ 'ASSETS_TREE.TREE_SECTION.TREE_VIEW.ARCHIVED' | translate }}
                  </p>
                </div>
              }
              <button
                type="button"
                class="w-8 h-8 flex-none bg-[#FFFFFF] rounded-xl flex items-center justify-center border-[thin] border-solid border-color-light-shade"
              >
                <mat-icon class="max-h-4 h-4 max-w-4 w-4 text-[16px] text-color-primary transition-all ease-in-out duration-300">
                  chevron_right
                </mat-icon>
              </button>
            </div>
          }
        }
        @if (isLoading()) {
          @for (skeleton of [].constructor(10); track $index) {
            <div class="w-full bg-white border-color-light-shade border-solid border-[thin] rounded-xl flex items-center gap-2 p-3">
              <palantir-skeleton class="w-8 h-8 flex-none rounded-full"></palantir-skeleton>
              <palantir-skeleton class="w-full h-8 grow"></palantir-skeleton>
              <palantir-skeleton class="w-8 h-8 flex-none"></palantir-skeleton>
            </div>
          }
        }
      }

      @if (options?.type === 'maintenance') {
        @if (!isLoading()) {
          @for (item of result()?.items; track $index; let i = $index) {
            <div
              class="cursor-pointer w-full bg-white border-color-light-shade border-solid border-[thin] rounded-xl flex flex-col items-center gap-4 p-4 hover:bg-color-surface hover:border-[#99BBFF] transition-all ease-in-out duration-300"
              (mouseover)="isHoveringIndex.set(i)"
              (mouseout)="isHoveringIndex.set(-1)"
              (click)="emitEvent(item)"
            >
              <div class="w-full flex flex-row items-center justify-between gap-3">
                <p class="text-sm font-medium p-0 m-0 text-color-neutral truncate">
                  {{ item.number }}
                </p>
                <div
                  class="flex-none flex flex-row px-[10px] py-1 rounded-full gap-[6px] items-center transition-all ease-in-out duration-300"
                  [style.backgroundColor]="isHoveringIndex() === i ? '#FFFFFF' : maintenanceStatusColorsOpacity10[item.status]"
                >
                  <div class="w-2 h-2 rounded-full" [style.backgroundColor]="maintenanceStatusColors[item.status]"></div>
                  <p class="p-0 m-0 text-xs font-medium" [style.color]="maintenanceStatusColors[item.status]">
                    {{ item.status | translateMaintenanceStatus }}
                  </p>
                </div>
              </div>
              <div
                class="w-full h-[1px] transition-all ease-in-out duration-300"
                [style.backgroundColor]="isHoveringIndex() === i ? '#99BBFF' : '#D4DEF1'"
              ></div>
              <div class="flex flex-col w-full">
                <p class="items-start text-sm font-normal p-0 m-0 text-color-neutral-secondary">
                  {{ 'ASSETS_TREE.DETAILS_SECTION.MAINTENANCES.WARRANTY' | translate }}
                </p>
                <div class="flex flex-row">
                  @if (item.warrantySummary?.status) {
                    @if (item.warrantySummary?.status) {
                      <app-warranty-status-label
                        class="items-start"
                        [status]="item.warrantySummary?.status"
                        [isHovering]="isHovering()"
                      ></app-warranty-status-label>
                    }
                  } @else {
                    -
                  }
                </div>
              </div>
              <div class="flex flex-col w-full">
                <p class="text-sm font-normal p-0 m-0 text-color-neutral-secondary">
                  {{ 'ASSETS_TREE.DETAILS_SECTION.MAINTENANCES.TYPE' | translate }}
                </p>
                <p class="text-sm font-normal p-0 m-0 text-color-neutral">
                  {{ item.maintenanceType?.name }}
                </p>
              </div>
              <div class="flex flex-col w-full">
                <p class="text-sm font-normal p-0 m-0 text-color-neutral-secondary">
                  {{ 'ASSETS_TREE.DETAILS_SECTION.MAINTENANCES.OPENED_AT' | translate }}
                </p>
                <p class="text-sm font-normal p-0 m-0 text-color-neutral">
                  {{ item.openedAt | date: 'dd/MM/yyyy HH:mm' }}
                </p>
              </div>
              <div class="flex flex-col w-full">
                <p class="text-sm font-normal p-0 m-0 text-color-neutral-secondary">
                  {{ 'ASSETS_TREE.DETAILS_SECTION.MAINTENANCES.DESCRIPTION' | translate }}
                </p>
                <p class="text-sm font-normal p-0 m-0 text-color-neutral line-clamp-2">
                  {{ item.message }}
                </p>
              </div>
            </div>
          }
        }
        @if (isLoading()) {
          @for (skeleton of [].constructor(10); track $index) {
            <div
              class="w-full bg-white border-color-light-shade border-solid border-[thin] rounded-xl flex flex-col items-center gap-4 p-4"
            >
              <div class="w-full flex flex-row items-center justify-between gap-3">
                <palantir-skeleton class="grow h-4 rounded-lg"></palantir-skeleton>
                <palantir-skeleton class="flex-none w-[90px] h-4 rounded-lg"></palantir-skeleton>
              </div>
              <div class="w-full h-[1px] bg-color-light-shade"></div>
              <div class="flex flex-col w-full">
                <p class="text-sm font-normal p-0 m-0 text-color-neutral-secondary">
                  {{ 'ASSETS_TREE.DETAILS_SECTION.MAINTENANCES.TYPE' | translate }}
                </p>
                <palantir-skeleton class="w-full h-4 rounded-lg mt-[2px]"></palantir-skeleton>
              </div>
              <div class="flex flex-col w-full">
                <p class="text-sm font-normal p-0 m-0 text-color-neutral-secondary">
                  {{ 'ASSETS_TREE.DETAILS_SECTION.MAINTENANCES.OPENED_AT' | translate }}
                </p>
                <palantir-skeleton class="w-full h-4 rounded-lg mt-[2px]"></palantir-skeleton>
              </div>
              <div class="flex flex-col w-full">
                <p class="text-sm font-normal p-0 m-0 text-color-neutral-secondary">
                  {{ 'ASSETS_TREE.DETAILS_SECTION.MAINTENANCES.DESCRIPTION' | translate }}
                </p>
                <palantir-skeleton class="w-full h-4 rounded-lg mt-[2px]"></palantir-skeleton>
              </div>
            </div>
          }
        }
      }
    </div>
  </ng-scrollbar>

  <div
    class="flex-none flex px-6 py-3 flex-row items-center justify-between w-full min-h-16 h-16 border-t-[thin] border-color-light-shade border-solid border-x-0 border-b-0 gap-3"
  >
    @if (!isLoading()) {
      <p class="text-color-neutral-secondary text-[13px] font-medium p-0 m-0">
        {{
          'ASSETS_TREE.DETAILS_SECTION.PAGES.PAGINATION'
            | translate
              : {
                  total: result()?.totalCount,
                  offset: offset() + 1,
                  limit: paginationLimit(),
                }
        }}
      </p>
    }

    @if (isLoading()) {
      <palantir-skeleton class="w-full h-5 rounded-lg"></palantir-skeleton>
    }

    <div class="flex flex-row items-center gap-2">
      <palantir-button
        layout="icon"
        theme="outline"
        [attr.disabled]="isLoading() || !hasFirstPage()"
        icon="first-page-outline"
        (click)="toFirstPage()"
      ></palantir-button>
      <palantir-button
        layout="icon"
        theme="outline"
        [attr.disabled]="isLoading() || !hasPreviousPage()"
        icon="arrow-backward-outline"
        (click)="toPreviousPage()"
      ></palantir-button>
      <palantir-button
        layout="icon"
        theme="outline"
        [attr.disabled]="isLoading() || !hasNextPage()"
        icon="arrow-forward-outline"
        (click)="toNextPage()"
      ></palantir-button>
      <palantir-button
        layout="icon"
        theme="outline"
        [attr.disabled]="isLoading() || !hasLastPage()"
        icon="last-page-outline"
        (click)="toLastPage()"
      ></palantir-button>
    </div>
  </div>
</div>
